import React from 'react';
import PropTypes from 'prop-types';
import without from 'lodash/without';
import ChevronRight from 'common/icons/ChevronRight';
import compareAsc from 'date-fns/compareAsc';

import DropdownMenu from '@radix-ui/react-dropdown-menu';
import Check from 'common/icons/Check';
import { useTouchpointData } from 'common/components/TouchpointEditor/contexts/TouchpointDataContext';
import { useSessions } from 'common/components/TouchpointEditor/contexts/SessionsContext';
import {
    StyledDropdownSubContent,
    StyledDropDownMenuSubTrigger,
    CheckboxSubItem,
    CheckboxIndicator,
    CheckboxFrame,
    Filterlabel,
    FilterIndicator,
} from './SessionFilter.styles';

const sortTimes = (times) =>
    times.sort((a, b) => {
        const timeA = new Date(`1970/01/01 ${a}`);
        const timeB = new Date(`1970/01/01 ${b}`);

        return compareAsc(timeA, timeB);
    });

export default function SessionStartTimesSubFilter({
    backgroundColor,
    backgroundColorHover,
    fontColor,
    fontSize,
    fontFamily,
    iconColor,
    borderColor,
    displayLabel,
}) {
    const {
        theme: { activeFonts, colors },
    } = useTouchpointData();
    const sessions = useSessions();

    const onFilteredStartTimeSelect = (startTime) => {
        const updatedSessionStartTimeFilterIds = sessions.filters.startTimes.includes(startTime)
            ? without(sessions.filters.startTimes, startTime)
            : sessions.filters.startTimes.concat(startTime);

        sessions.filters.setStartTimes(updatedSessionStartTimeFilterIds);
    };
    const sessionFiltersArray = sessions.uniqueStartTimes ? sortTimes(sessions.uniqueStartTimes) : [];
    const startTimes = sessionFiltersArray.map((startTime) => {
        const checked = sessions.filters.startTimes.includes(startTime);
        return (
            <CheckboxSubItem
                key={startTime}
                checked={checked}
                $backgroundColorHover={colors[backgroundColorHover]}
                $borderColor={borderColor}
                onCheckedChange={() => onFilteredStartTimeSelect(startTime)}
                onSelect={(e) => e.preventDefault()}
            >
                <CheckboxFrame $iconColor={iconColor}>
                    <CheckboxIndicator>
                        <Check />
                    </CheckboxIndicator>
                </CheckboxFrame>
                {startTime}
            </CheckboxSubItem>
        );
    });

    return (
        <DropdownMenu.Sub>
            <StyledDropDownMenuSubTrigger
                $fontColor={colors[fontColor]}
                $backgroundColor={colors[backgroundColor]}
                $fontSize={fontSize}
                $fontFamily={activeFonts[fontFamily]}
                $backgroundColorHover={colors[backgroundColorHover]}
                $iconColor={iconColor}
                $borderColor={borderColor}
            >
                <Filterlabel>
                    {displayLabel}
                    {sessions.filters.startTimes?.length > 0 ? (
                        <FilterIndicator $backgroundColor={colors[fontColor]} $fontColor={colors[backgroundColor]}>
                            {sessions.filters.startTimes?.length}
                        </FilterIndicator>
                    ) : null}
                </Filterlabel>
                <ChevronRight />
            </StyledDropDownMenuSubTrigger>
            <StyledDropdownSubContent
                $fontColor={colors[fontColor]}
                $backgroundColor={colors[backgroundColor]}
                $fontSize={fontSize}
                $fontFamily={activeFonts[fontFamily]}
                $backgroundColorHover={colors[backgroundColorHover]}
            >
                {startTimes}
            </StyledDropdownSubContent>
        </DropdownMenu.Sub>
    );
}

SessionStartTimesSubFilter.propTypes = {
    backgroundColor: PropTypes.number.isRequired,
    backgroundColorHover: PropTypes.number.isRequired,
    fontColor: PropTypes.number.isRequired,
    fontSize: PropTypes.number.isRequired,
    fontFamily: PropTypes.number.isRequired,
    displayLabel: PropTypes.string.isRequired,
    iconColor: PropTypes.string.isRequired,
    borderColor: PropTypes.string.isRequired,
};
